<template>
	<div class="order-search-body">
		<div class="filters-box-row">
			<div class="filters-container">
				<div class="input-box">
					<el-select v-model="dateType" class="select-input" size='small'>
						<el-option :value="0" label="下单时间"></el-option>
						<el-option :value="1" label="统计时间"></el-option>
						<el-option :value="2" label="申请提现时间"></el-option>
					</el-select>
					<el-date-picker
						@change="searchTime"
						v-model="dateValue"
						:clearable="false"
						:unlink-panels='true'
						:default-time="['00:00:00', '23:59:59']"
						class="time-input"
						size="small"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>单号：</span>
					<el-input
						class="search-input"
						v-model="number"
						placeholder="请输入订单/退单编号"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>客户名称：</span>
					<el-input
						class="search-input"
						v-model="customer"
						placeholder="请输入客户名称"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<!-- <div class="filters-container">
				<div class="input-box">
					<span>员工名称：</span>
					<el-select v-model="staff" class="filter-input" size='small' filterable multiple collapse-tags>
						<el-option value="" label="全部"></el-option>
						<el-option v-for="item in staffList" :value="item.staffname" :label="item.staffname" :key="item.staffname"></el-option>
					</el-select>
				</div>
			</div> -->
			<div class="filters-container" style="position:relative">
				<!-- <el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button> -->
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="filters-box-row filters-box-row2">
			<div class="filters-container" v-show="!collapse">
				<div class="input-box">
					<span>返佣方式：</span>
					<el-select v-model="commissionType" class="filter-input" size='small'>
						<el-option value="-1" label="全部"></el-option>
						<el-option value="1" label="百分比"></el-option>
						<el-option value="2" label="固定值"></el-option>
						<!-- <el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option> -->
					</el-select>
				</div>
				<div class="input-box">
					<span>提现状态：</span>
					<el-select v-model="cashOutStatus" class="filter-input" size='small'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="0" label="待申请"></el-option>
						<el-option :value="1" label="待审核"></el-option>
						<el-option :value="2" label="已审核"></el-option>
					</el-select>
				</div>
				<!-- <div class="input-box">
					<span>商品信息：</span>
					<el-input
						class="search-input"
						v-model="product"
						placeholder="请输入商品名称/编号"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
				<div class="input-box">
					<span>规格信息：</span>
					<el-input
						class="search-input"
						v-model="spec"
						placeholder="请输入规格名称/编号"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div> -->
			</div>
		</div>
		<div class="filters-box-row filters-box-row3" style="display: flex; align-item: center;justify-content: space-between;">
			<!-- <el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left: 0px" v-if="AuthorityList['11_0002_0003_00']" @click="liquidate(1)">勾销</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn" v-if="AuthorityList['11_0002_0003_00']" @click="liquidate(0)">取消勾销</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn" v-if="AuthorityList['11_0002_0003_00']" @click="auditing(1)">已审核</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn" v-if="AuthorityList['11_0002_0003_00']" @click="auditing(0)">未审核</el-button> -->
			<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" @click="listExport">
				<div></div>
				导出
			</el-button>
			<div>明细范围：不记录已提现成功的金额订单明细</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			dateValue: [],
			collapse: false,
			dateType: 0,
			commissionType: '-1',
			number: '',
			cashOutStatus: -1,
			customer: '',
			staff: '',
			params: {}
			// product: '',
			// spec: ''
		}
	},
	created () {
		if (this.$route.query.staff) {
			this.staff = this.$route.query.staff
		}
		// if (this.$route.query.customer !== '') {
		// 	debugger
		// 	this.customer = this.$route.query.customer
		// }
		// if (this.$route.query.dateValue && this.$route.query.dateValue.length > 0) {
		// 	this.dateValue = this.$route.query.dateValue
		// } else {
		// 	this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:0', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
		// }
		// if (window.sessionStorage.getItem('rebateStatisticsDetailSelect')) {
		// 	let data = JSON.parse(window.sessionStorage.getItem('rebateStatisticsDetailSelect'))
		// 	// this.dateValue = data.dateValue
		// 	// this.number = data.number
		// 	// this.dateType = data.dateType
		// 	// this.commissionType = data.commissionType
		// 	this.staff = data.staff
		// 	// this.staff = data.customer
		// 	// this.product = data.product
		// 	// this.cashOutStatus = data.cashOutStatus
		// 	// this.spec = data.spec
		// }
		// if (window.sessionStorage.getItem('afterSearchTime')) {
		// 	this.dateValue = JSON.parse(window.sessionStorage.getItem('afterSearchTime'))
		// } else {
		// 	this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
		// }
	},
	methods: {
		listExport () {
			let params = this.params
			params.orderKey = this.orderKey
			params.orderBy = this.orderBy
			params.dateType = this.dateType
			params.number = this.number
			params.customer = this.customer
			params.commissionType = this.commissionType
			params.cashOutStatus = this.cashOutStatus
			params.staff = this.staff
			if (this.dateValue.length > 0) {
				params.beginDate = this.dateValue[0]
				params.endDate = this.dateValue[1]
			}
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/commission/return/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(JSON.stringify(params))
		},
		download (blobUrl) {
			const a = document.createElement('a')
			a.style.display = 'none'
			let name = ''
			if (this.dateValue.length > 0) {
				name = this.dateValue[0] + '-' + this.dateValue[1] + '提成统计结果.xls'
			} else {
				name = '提成统计结果.xls'
			}
			name = name.replace(/:/g, '：')
			a.download = name
			a.href = blobUrl
			a.click()
		},
		// // 勾销
		// liquidate (type) {
		// 	if (this.ids.length < 1) {
		// 		this.$message.error('请至少选择一条订单！')
		// 		return false
		// 	}
		// 	let params = {
		// 		cashOutStatus: type,
		// 		commissionResultIds: this.ids.join(',')
		// 	}
		// 	this.$store.dispatch('requestPost', {
		// 		url: `${this.$fxBaseApi.urlQIVShop}/commission/result/liquidateflag`,
		// 		data: params
		// 	}).then(res => {
		// 		if (res.result) {
		// 			this.$message.success(res.msg)
		// 			this.$emit('modifySuc')
		// 		} else {
		// 			this.$message.error('勾销失败，请稍后重试')
		// 		}
		// 	}).catch(error => {
		// 		this.$message.error(error.msg)
		// 	})
		// },
		// auditing (type) {
		// 	if (this.ids.length < 1) {
		// 		this.$message.error('请至少选择一条订单！')
		// 		return false
		// 	}
		// 	let params = {
		// 		auditingflag: type,
		// 		commissionResultIds: this.ids.join(',')
		// 	}
		// 	this.$store.dispatch('requestPost', {
		// 		url: `${this.$fxBaseApi.urlQIVShop}/commission/result/auditingflag`,
		// 		data: params
		// 	}).then(res => {
		// 		if (res.result) {
		// 			this.$message.success(res.msg)
		// 			this.$emit('modifySuc')
		// 		} else {
		// 			this.$message.error('审核失败，请稍后重试')
		// 		}
		// 	}).catch(error => {
		// 		this.$message.error(error.msg)
		// 	})
		// },
		searchTime (value) {
			// window.sessionStorage.setItem('afterSearchTime', JSON.stringify(value))
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.dateValue = []
			}
			if (!(this.dateValue === null || this.dateValue.length === 0)) {
				var begintime = this.dateValue[0]
				var endtime = this.dateValue[1]
				// 判断时间跨度是否大于12个月
				var arr1 = begintime.split('-')
				var arr2 = endtime.split('-')
				arr1[1] = parseInt(arr1[1])
				arr1[2] = parseInt(arr1[2])
				arr2[1] = parseInt(arr2[1])
				arr2[2] = parseInt(arr2[2])
				var flag = true
				if (arr2[0] - arr1[0] > 1) {
					flag = false
				} else if (arr2[0] - arr1[0] === 1) {
					if (arr1[1] < arr2[1]) { // 月相隔大于12个月
						flag = false
					} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
						if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
							flag = false
						}
					}
				}
				if (!flag) {
					this.$message.error('时间范围不得超过12个月！')
					return false
				}
				return true
			} else {
				return true
			}
		},
		search () {
			// this.dateValue = this.dateValue === null ? [] : this.dateValue
			if (this.checkTime()) {
				this.$emit('handleSearch', { staff: this.staff, commissionType: this.commissionType, number: this.number, customer: this.customer, dateValue: this.dateValue, dateType: this.dateType, cashOutStatus: this.cashOutStatus })
			}
		},
		// // 导出
		// exportExcel () {
		// 	this.$emit('exportExcel')
		// },
		clear () {
			// let value = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			// this.searchTime(value)
			this.clearAllInput()
			this.search()
		},
		clearAllInput () {
			this.dateValue = []
			this.number = ''
			this.commissionType = '-1'
			this.customer = ''
			this.dateType = 0
			this.cashOutStatus = -1
			// if (this.$route.query.customer) {
			// 	this.customer = this.$route.query.customer
			// } else {
			// 	this.customer = ''
			// }
			// if (this.$route.query.dateValue) {
			// 	this.dateValue = this.$route.query.dateValue
			// }
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	padding: 10px 0 0 0;
	width :100%;
	line-height :50px;
	min-width :600px;
	box-sizing: border-box
	text-align: left
	.select-input {
		width: 125px!important;
	}
	&.filters-box-row2 {
		padding-top: 0;
		.filters-container {
			display: flex
			flex-wrap: wrap
			.input-box {
				margin-right: 5px
			}
		}
	}
	&.filters-box-row3 {
		padding-top: 5px;
		height: 50px
	}
	.filters-container {
		margin-right: 5px
		.el-input {
			width: 155px
		}
		.time-input {
			width: 310px;
			margin-left: 10px;
		}
		.filter-input {
			width: 155px
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			vertical-align: sub;
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
}
</style>
<style lang="stylus">
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
</style>
